import { Dict } from './Types';

import utils = egr.wcf.utils;

/**
 * Strips the trailing slash from the given url.
 */
export function stripTrailingSlash(value: string): string {
    if (utils.string.isNullOrEmpty(value)) {
        return value;
    }
    return value.replace(/\/$/, '');
}

/**
 * Strips the query string from the given url.
 */
export function stripQueryString(url: string): string {
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    a.href = url;
    a.search = '';

    const value: string = a.href;
    if (value.endsWith('?')) { // Fix for IE/EDGE
        return value.substring(0, value.length - 1);
    }

    return value;
}

/**
 * Strips the hash part from the given url.
 */
export function stripHash(url: string): string {
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    a.href = url;
    a.hash = '';

    const value: string = a.href;
    if (value.endsWith('#')) {
        return value.substring(0, value.length - 1);
    }

    return value;
}

/**
 * Extracts the query string from any given url.
 */
export function getQueryString(url: string): string {
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    a.href = url;
    return a.search.slice(1);
}

/**
 * Generates an object with key value pairs from an url encoded query string.
 */
export function parseQueryString(query: string): Dict {
    // http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    let match: RegExpExecArray | null;
    const pl: RegExp = /\+/g;  // Regex for replacing addition symbol with a space
    const search: RegExp = /([^&=]+)=?([^&]*)/g;
    const decode: (s: string) => string = (s: string) => {
        return decodeURIComponent(s.replace(pl, ' '));
    };

    const urlParams: Dict = {};
    while (match = search.exec(query)) {
        urlParams[decode(match[1])] = decode(match[2]);
    }

    return urlParams;
}

/**
 * Generates an url encoded query string from an object with key
 * value paris.
 */
export function buildQueryString(parameters: Dict<string | number | undefined | null>): string {
    return Object.keys(parameters).map((key: string): string => {
        const value: string | number | undefined | null = parameters[key];
        if (value != null && value !== '') { // Note: we cant use utils.string.isNotNullOrEmpty because numbers are not allowed
            return encodeURIComponent(key) + '=' + encodeURIComponent(value.toString());
        }

        return encodeURIComponent(key);
    }).join('&');
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/utils/Url.ts